import DateFnsUtils from '@date-io/date-fns';
import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  createMuiTheme,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Snackbar,
  Button,
  FormControlLabel,
  Switch,
  Tooltip, DialogContent, DialogActions, Dialog, DialogTitle
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { setTask } from '../../store/actions/taskActions';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetLabours,
  resetMaterials,
  resetDefects
} from '../../store/actions';
import ProductWarrantyInfo from 'src/components/ProductWarrantyInfo';

const useStyles = makeStyles(theme => ({
  root: {},
  fieldsGaranti: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  cardsMax: {
    maxHeight: 242,
    minHeight: 242
  },
  FormControlLabel: {
    padding: 12
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale
};
function Garanti({
  className,
  ReceiptNo,
  readonly,
  tasks,
  defectReducer,
  labourReducer,
  materialReducer,
  setTask,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetLabours,
  resetMaterials,
  resetDefects
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const locale = localStorage.getItem('i18nextLng');
  const [WarrantyData, setWarrantyData] = React.useState([]);
  const [Loading, setLoading] = useState(false);
  const [warningOpen, setWarningOpen] = useState(false);
  const [NoInvoice, setNoInvoice] = useState(false);
  const GarantiTipiDeger = '';
  const SessionUser = getUser();
  const garantiTarihiDeger = '';
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [GarantiData, setGarantiData] = useState({});
  const [uyariTip, setUyariTip] = useState();
  const [GarantiTipi, setGarantiTipi] = React.useState(0);
  const [ProjectCode, setProjectCode] = React.useState(null);
  const [originalWarrantyDate, setOriginalWarrantyDate] = useState('')
  const [originalCheck, setOriginalCheck] = useState(false)
  const [garantiTarihi, setGarantiTarihi] = React.useState(null);
  const [billingConsumer, setBillingConsumer] = useState({});
  const [open, setOpen] = React.useState(false);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const [searchBillingConsumer, setSearchBillingConsumer] = useState('');
  const [optionsBillingConsumer, setOptionsBillingConsumer] = React.useState([]);
  const loading = open && optionsBillingConsumer.length === 0;
  const [openProductWarrantyInfoDialog, setOpenProductWarrantyInfoDialog] = useState(false);
  const [productWarrantyData, setProductWarrantyData] = useState([]);
  const [selectedWarrantyTypeId, setSelectedWarrantyTypeId] = React.useState(null);


  const handleRowClick = (WarrantyTypeId) => {
    setSelectedWarrantyTypeId(WarrantyTypeId);
    setOpenProductWarrantyInfoDialog(false);
  };


  React.useEffect(() => {
    if (searchBillingConsumer && searchBillingConsumer.length > 3) {
      axios
        .get(
          `/BillingConsumerSearch/${searchBillingConsumer.toString()}`
        )
        .then(res => {
          if (res.data.length > 0) {
            // Assuming res.data is an array of objects with a 'Dsc' property
            setOptionsBillingConsumer(res.data);
          } else {
            setOptionsBillingConsumer([]);
          }
        })
        .catch(err => {
          setOptionsBillingConsumer([]);
        });
    }
  }, [searchBillingConsumer]);

  const GarantiData1 = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );

  useEffect(() => {
    if (GarantiData1.length !== 0) {
      setGarantiData(GarantiData1[0]);
      setGarantiTipi(GarantiData1[0].WarrantyTypeId);
      setGarantiTarihi(GarantiData1[0].WarrantyDate === '1900-01-01T00:00:00' ? null : GarantiData1[0].WarrantyDate);
      setNoInvoice(GarantiData1[0].NoInvoice);
      setProjectCode(GarantiData1[0].ProjectCode);
      if (GarantiData1[0].BillingConsumer) {
        setOptionsBillingConsumer(GarantiData1[0].BillingConsumer);
        setBillingConsumer(GarantiData1[0].BillingConsumer[0]);
      }

      if (!originalCheck && GarantiData1[0].WarrantyDate) {
        setOriginalWarrantyDate(GarantiData1[0].WarrantyDate)
        setOriginalCheck(true)
      }
    } else {
      setGarantiData({});
      setGarantiTipi(0);
      setGarantiTarihi(null);
      setNoInvoice(0);
      setProjectCode('');
    }

  }, [ReceiptNo, tasks.tasks]);

  useEffect(() => {
    setLoading(true);
    axios
      .get('/GetSiriusWarrantyType')
      .then(response => {
        const Deger = response.data;
        setWarrantyData(Deger);
        setLoading(false);
      })
      .catch(error => {
        setWarrantyData([]);
        setLoading(false);
      });
  }, [SessionUser.TechnicianId]);


  useEffect(() => {
    if (GarantiData1.length !== 0) {
      const formattedDate = garantiTarihi == null
        ? moment(new Date()).format("YYYY-MM-DD") 
        : moment(garantiTarihi).format("YYYY-MM-DD");
      const request = {
        ProductCode: GarantiData1[0].ModelCode,
        ProductionMonth: GarantiData1[0].ProductionMonth,
        ProductionYear: GarantiData1[0].ProductionYear,
        SerialNr: GarantiData1[0].ProductSerialPrint,
        Revision: 0,
        Date: formattedDate, 
        RetailerId: GarantiData1[0].RetailerId,
        ConsumerId: GarantiData1[0].ConsumerId
      }
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
  
      axios.post('/GetProductWarrantyInfo', request, config)
      .then((response) => {
        setProductWarrantyData(response.data);
      }).catch((error) => {
        setProductWarrantyData([]);
      });
    }
  }, [ReceiptNo, tasks.tasks]);

  useEffect(() => {
    if (selectedWarrantyTypeId !== null) {
      GarantiTipihandleChange({ target: { value: selectedWarrantyTypeId } });
    }
    setSelectedWarrantyTypeId(null);
  }, [selectedWarrantyTypeId]);

  const checkWarranty = () => {
    setOpenProductWarrantyInfoDialog(true);
  };

  if (GarantiData?.length === 0) {
    return null;
  }

  const showTransportClearError = () => {
    setUyariTip('error');
    setUyariAciklama(t('transport_delete_failed', {
      defaultValue: 'Transport could not be removed. Please remove it manually on the Defect page.'
    }));
    setUyari(true);
  };

  // Pakistan: transport/extra payment prices depend on the warranty type, so they are cleared too.
  const clearTransportForWarrantyChange = job => {
    const hasTransport =
      (job.WorkOrderTransport?.[0]?.MaterialPrice || 0) > 0 ||
      (job.WorkOrderExtra?.[0]?.MaterialPrice || 0) > 0;
    if (hasTransport) {
      const data = {
        Km: 0,
        MaterialId: 0,
        PriceId: 0,
        Price: 0,
        VatRate: 0,
        VatId: 0,
        ExtraPrice: 0,
        WorkOrderId: parseInt(ReceiptNo),
        ExtraFeeNote: job.WorkOrderExtra?.[0]?.ExtraFeeNote || '',
        EmployeeId: SessionUser.TechnicianId
      };
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      axios
        .post('/SetTransport', data, config)
        .then(response => {
          const errorCode = response.data?.ErrorCode;
          if (errorCode !== undefined && String(errorCode) !== '0') {
            showTransportClearError();
          }
        })
        .catch(() => {
          showTransportClearError();
        });
    }
    return {
      ...job,
      WorkOrderTransport: [
        {
          MaterialId: 0,
          DefectId: 0,
          MaterialCode: 'TRNS',
          Count: 0,
          MaterialDesc: 'Route Payment',
          MaterialPrice: 0,
          MaterialPriceWithWat: 0,
          MaterialPriceId: 0,
          MaterialPriceListId: 0,
          VatRate: 0,
          VatId: 0
        }
      ],
      WorkOrderExtra: [
        {
          MaterialId: 0,
          DefectId: 0,
          MaterialCode: 'EXT',
          Count: 1,
          MaterialDesc: 'Extra Payment',
          MaterialPrice: 0,
          MaterialPriceWithWat: 0,
          MaterialPriceId: 0,
          MaterialPriceListId: 0,
          VatRate: 0,
          VatId: 0
        }
      ]
    };
  };

  const GarantiTipihandleChange = event => {
    let job = tasks.tasks.find(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    let WarrantyTypeText = WarrantyData.filter(
      x => x.WarrantyId === event.target.value
    );

    if (job.WarrantyTypeId !== WarrantyTypeText[0].WarrantyId) {
      setUyari(true);
      setUyariTip('default');
      setUyariAciklama(t('warranty_changed_message'));
      resetLabours();
      resetMaterials();
      resetDefects();
      getDefectRequest(job.ModelCode, 1, []);
      getMaterialRequest(
        job.ModelCode,
        WarrantyTypeText[0].WarrantyId,
        1,
        0,
        0,
        job?.ReceiptNo || 0
      );
      getLabourRequest(job.ModelCode, WarrantyTypeText[0].WarrantyId, 1, '',job?.ReceiptNo || 0);
      job = { ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: [] };
      if (parseInt(SessionUser.TenantId) === 75) {
        job = clearTransportForWarrantyChange(job);
      }
    }
    job = {
      ...job,
      WarrantyTypeId: event.target.value,
      WarrantyTypeText: WarrantyTypeText[0].FieldText,
      WarrantyGroupId: WarrantyTypeText[0].WarrantyGroupId
    };
    setTask(job);
    setGarantiTipi(event.target.value);
  };

  const GarantiTarihihandleChange = value => {
    let Deger = moment(value).format('YYYY-MM-DD');
    let job = GarantiData;
    job = {
      ...job,
      WarrantyDate: Deger
    };
    setTask(job);
    setGarantiTarihi(Deger);
  };

  const handleOnCheck = event => {
    var NoInvoice = false;
    var Deger;
    let job = GarantiData;
    var currentDate = new Date();

    if (event.target.checked) {
      NoInvoice = true;
      Deger = moment(GarantiData.ProductionYear + '.' + GarantiData.ProductionMonth + '.01').add('6', 'M').format('YYYY.MM.DD');
      if (Deger > GarantiData.WarrantyDate) {
        setGarantiTarihi(currentDate.getDay() + "/" + currentDate.getMonth() + "/" + currentDate.getFullYear());
      }
      else {
        setGarantiTarihi(Deger);
      }
    }
    else {
      NoInvoice = false;
      Deger = originalWarrantyDate;
      setGarantiTarihi(Deger);

    }

    job = {
      ...job,
      NoInvoice: NoInvoice,
      WarrantyDate: Deger
    };

    setTask(job);
    setNoInvoice(NoInvoice);
  };

  const handleWarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarningOpen(false);
  };

  const updateText = data => {
    let job = GarantiData;
    job = {
      ...job,
      BillingConsumer: [{
        Dsc: data.Dsc,
        Id: data.Id
      }]
    };
    setTask(job);
    setBillingConsumer(data);
  };

  return (
    <Card className={classes.cardsMax}>
      <Snackbar
        open={warningOpen}
        autoHideDuration={6000}
        onClose={handleWarningClose}
      >
        <Alert
          onClose={handleWarningClose}
          severity="warning"
          message={t('lblOutWarrantyWarning')}
          variant={'warning'}
        ></Alert>
      </Snackbar>
      <Snackbar
        open={uyari}
        autoHideDuration={6000}
        onClose={uyariKapat}
      >
        <Alert
          onClose={uyariKapat}
          severity="warning"
          message={uyariAciklama || ''}
          variant={uyariTip}
        ></Alert>
      </Snackbar>

      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader title={t('Garanti_Detay')} />
      <Divider />
      <CardContent className={classes.contentGaranti}>
        <form className={clsx(classes.root, className)}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={9} lg={9}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDatePicker
                    margin="normal"
                    color="primary"
                    size="small"
                    // disabled={isWarrantyChecked}
                    fullWidth
                    inputVariant="outlined"
                    id="GarantiTarihi"
                    label={t('Fatura_Tarihi')}
                    invalidDateMessage={t('hatali_tarih')}
                    format="dd.MM.yyyy"
                    variant="outlined"
                    value={garantiTarihi}
                    disabled={NoInvoice === true}
                    onChange={e => GarantiTarihihandleChange(e)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <FormControlLabel className={classes.FormControlLabel}
                control={
                  <Switch
                    color="primary"
                    readOnly
                    checked={NoInvoice === true || false}
                    onChange={handleOnCheck}
                    disabled={garantiTarihi === '' || GarantiData.ProductionYear === 0 || GarantiData.ProductionMonth === 0 || GarantiData.ModelCode === 0 || GarantiData.SerialNumber === 0 || GarantiData.BrandCode === 0}
                    name="AttributeId"
                  />
                }
                label={t('lblNoInvoice')}
              />
            </Grid>
            <Grid item xs={12} sm={9} lg={9}>
              <TextField
                size="small"
                fullWidth
                select
                value={GarantiTipi}
                onChange={GarantiTipihandleChange}
                variant="outlined"
              >
                {WarrantyData.map(p => {
                  return (
                    <MenuItem key={p.WarrantyId} value={p.WarrantyId}>
                      {p.FieldText}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <Button
                disableElevation
                variant="contained"
                color="primary"
                size="small"
                disabled={garantiTarihi === '' || GarantiData.ProductionYear === 0 || GarantiData.ProductionMonth === 0 || GarantiData.ModelCode === 0 || GarantiData.SerialNumber === 0 || GarantiData.BrandCode === 0}
                endIcon={<CheckCircleOutlineIcon>Check</CheckCircleOutlineIcon>}
                onClick={() => { checkWarranty(); }}
              >
                {t('lblCheck')}
              </Button>
            </Grid>
            {GarantiData.WarrantyGroupId === 2 ?
              <Grid item xs={12} sm={9} lg={9}>
                <Tooltip title={t('lblHelperText')} arrow>
                  <Autocomplete
                    id="asynchronous-demo"
                    open={open}
                    value={billingConsumer}
                    onOpen={() => {
                      setOpen(true);
                    }}
                    onClose={() => {
                      setOpen(false);
                    }}
                    options={optionsBillingConsumer}
                    getOptionLabel={(option) => (option.Dsc)}
                    loading={loading}
                    onChange={(event, newInputValue) => {
                      if (newInputValue && newInputValue.Dsc) {
                        updateText(newInputValue);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        onChange={(e) => {
                          setSearchBillingConsumer(e.target.value);
                        }}
                        variant="outlined"
                        label={t('lblSearchBilling')}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Tooltip>
              </Grid> : null
            }
          </Grid>
        </form>
      </CardContent>
      <Dialog open={openProductWarrantyInfoDialog} onClose={() => setOpenProductWarrantyInfoDialog(false)} fullWidth maxWidth="lg">
        <DialogTitle>{t('lblWarrantyInformation')}</DialogTitle>
        <DialogContent>
          <ProductWarrantyInfo data={productWarrantyData} onRowClick={handleRowClick} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenProductWarrantyInfoDialog(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Garanti.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer
  }),
  {
    setTask,
    getDefectRequest,
    getLabourRequest,
    getMaterialRequest,
    resetLabours,
    resetMaterials,
    resetDefects
  }
)(Garanti);
